import React, { useEffect, useState } from "react";
import { ListGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useRouteLoaderData } from "react-router-dom";

import { Awesome } from "@components/Helpers";
import { scroll_to_top, url_reverse } from "@components/Utils";

export function GameMenu({ active }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const gameCommonInfo = useRouteLoaderData("gameCommonInfo");
    const [subMenu, setSubMenu] = useState({});
    const [innerMenu, setInnerMenu] = useState({});
    const [inner, setInner] = useState("");

    const toggleMenu = (nested) => {
        const newState = { ...subMenu };
        newState[nested] = !subMenu[nested];
        setSubMenu(newState);
        setInnerMenu({});
    };
    const toggleInnerMenu = (nested) => {
        const newState = { ...innerMenu };
        newState[nested] = !innerMenu[nested];
        setInnerMenu(newState);
    };

    const activeClass = (section, inner_name = "") => {
        if (active === section && inner_name && !inner) {
            setInner(inner_name);
        }
        return active === section ? "active" : "";
    };

    const changeUrl = (d) => {
        if (d.ahref) {
            if (d?.new_tab) {
                window.open(d.url, "_blank");
            } else {
                location.href = d.url;
            }
        } else {
            setSubMenu({}); // чистим инфу по меню
            setInnerMenu({});
            setInner("");
            navigate(d.url);
            scroll_to_top();
        }
    };

    useEffect(() => {
        if (active?.indexOf(".") > 1) {
            const mtch = active.match(/(.+?)\.(.+)/);
            if (mtch[1]) {
                const newState = { ...subMenu };
                newState[mtch[1]] = true;
                setSubMenu(newState);
            }
        }
    }, [active]);

    useEffect(() => {
        toggleInnerMenu(inner);
    }, [inner]);

    const drawBlock = (block) => {
        return Object.keys(block).map((k) => {
            const v = block[k];
            if (v.submenu) {
                return (
                    <React.Fragment key={`menu_${k}`}>
                        <a className="list-group-item" onClick={() => toggleMenu(k)}>
                            {v.is_super && (
                                <>
                                    <Awesome type="flash" color="red" />{" "}
                                </>
                            )}
                            <span>{v.name}</span>
                            <span className={`float-right ${subMenu && subMenu[k] ? "d-none" : ""}`}>
                                <Awesome type="angle-double-down" />
                            </span>
                            <span className={`float-right ${subMenu && subMenu[k] ? "" : "d-none"}`}>
                                <Awesome type="angle-double-up" />
                            </span>
                        </a>
                        {v.submenu.map((sv, ind) => (
                            <React.Fragment key={`menu_${ind}`}>
                                {sv.inner_menu && (
                                    <>
                                        <a
                                            key={`menu_${k}_${ind}`}
                                            className={`list-group-item list-group-item-nested ${
                                                subMenu && subMenu[k] ? "" : "d-none"
                                            }`}
                                            onClick={() => toggleInnerMenu(sv.name)}
                                        >
                                            <span>{sv.name}</span>
                                            <span
                                                className={`float-right ${
                                                    innerMenu && innerMenu[sv.name] ? "d-none" : ""
                                                }`}
                                            >
                                                <Awesome type="angle-double-down" />
                                            </span>
                                            <span
                                                className={`float-right ${
                                                    innerMenu && innerMenu[sv.name] ? "" : "d-none"
                                                }`}
                                            >
                                                <Awesome type="angle-double-up" />
                                            </span>
                                        </a>
                                        {sv.inner_menu.map((el, in_ind) => {
                                            return (
                                                <a
                                                    key={`menu_${el}_${in_ind}`}
                                                    className={`list-group-item list-group-item-nested-inner ${activeClass(
                                                        el.active,
                                                        sv.name
                                                    )} ${innerMenu && innerMenu[sv.name] ? "" : "d-none"}`}
                                                    onClick={() => changeUrl(el)}
                                                >
                                                    {el.name}
                                                </a>
                                            );
                                        })}
                                    </>
                                )}
                                {!sv.inner_menu && (
                                    <a
                                        key={`menu_${k}_${ind}`}
                                        className={`list-group-item list-group-item-nested ${activeClass(sv.active)} ${
                                            subMenu && subMenu[k] ? "" : "d-none"
                                        }`}
                                        onClick={() => changeUrl(sv)}
                                    >
                                        {sv.is_super && (
                                            <>
                                                <Awesome type="flash" color="red" />{" "}
                                            </>
                                        )}
                                        {sv.name}
                                    </a>
                                )}
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                );
            }
            return (
                <a key={`menu_${k}`} className={`list-group-item ${activeClass(k)}`} onClick={() => changeUrl(v)}>
                    {v.is_super && (
                        <>
                            <Awesome type="flash" color="red" />{" "}
                        </>
                    )}
                    {v.name}
                </a>
            );
        });
    };

    return (
        <div className="sticky-top-scroll dmg-sidebar">
            <ListGroup>
                {Object.keys(gameCommonInfo.game_menu_availability).map((hdr) => {
                    return (
                        <React.Fragment key={hdr}>
                            <strong className="my-1 ml-1">{hdr}</strong>
                            {drawBlock(gameCommonInfo.game_menu_availability[hdr])}
                        </React.Fragment>
                    );
                })}
            </ListGroup>
            {gameCommonInfo.parent && (
                <div className="mt-2 text-right">
                    <Link to={url_reverse("games:relationship", { game_id: gameCommonInfo.parent.id })}>
                        {t("Перейти в родительский проект")}
                    </Link>
                </div>
            )}
        </div>
    );
}
